import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function SqlAccessFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Get full access to your data'
            subHeader='Leverage SQL to tap into your Nutshell data and build custom reports for deeper business insights.'
            bullets={[
                'Access your data with SQL to create the custom reports you need.',
                'Easily connect with tools like Power BI and Tableau to visualize your insights.',
                'Get personalized support from our team to help you set up your SQL access and start analyzing.',
            ]}
            feature='sqlAccess'
        />
    );
}
